import { TailSpin, TailSpinProps } from "react-loader-spinner";

export const Loader = (props: TailSpinProps) => {
    const color = props.color || "#203d88";
    return <TailSpin {...props} color={color} />;
};
